import React from 'react'
import styled from 'styled-components'
import { Icon } from '@react95/core'
import {startWebamp} from '../utils/startWebamp';


const StyledShorcut = styled.div`
    margin-left: 20px;
    margin-top: 20px;
	align-items: center;
`;

function Shortcuts({ openExplorer }) {
    return (
        <div>
            <StyledShorcut>
                <Icon
                    className="pointer"
                    name="windows_explorer"
                    onClick={() => openExplorer()}
                />
                <div>Explorer</div>
            </StyledShorcut>
            <StyledShorcut>
                <Icon
                    className="pointer"
                    name="bulb"
                    onClick={()=>window.open('https://batudev.com', '_blank')}
                />
                <div>Website</div>
            </StyledShorcut>
            <StyledShorcut>
                <Icon
                    className="pointer"
                    name="media_cd"
                    onClick={()=>startWebamp()}
                />
                <div>Winamp</div>
            </StyledShorcut>
            <StyledShorcut>
                <Icon
                    className="pointer"
                    name="progman_21"
                    onClick={()=>window.open('https://tr.linkedin.com/in/batuhan-ye%C5%9Filyurt-597160284', '_blank')}
                />
                <div>LinkedIn</div>
            </StyledShorcut>
            <StyledShorcut>
                <Icon
                    className="pointer"
                    name="regedit_101"
                    onClick={()=>window.open('https://github.com/batuhanyslyrt0', '_blank')}
                />
                <div>GitHub</div>
            </StyledShorcut>
            <StyledShorcut>
                <Icon
                    className="pointer"
                    name="progman_13"
                    onClick={()=>window.open('https://www.instagram.com/batuhanyslyrt0', '_blank')}
                />
                <div>Instagram</div>
            </StyledShorcut>
        </div>
    )
}

export default Shortcuts
